import { NavLink, Outlet } from 'react-router-dom';
import { useSesion } from '../context/Sesion';
import { SiPuede } from './SiPuede';

export function Layout() {
  const { me, salir } = useSesion();
  return (
    <div className="app">
      <header className="cabecera">
        <div className="marca">
          <span className="logotipo">FONESTAR</span>
          <span className="producto">dwh · réplica de X3</span>
        </div>
        <nav className="menu" aria-label="Principal">
          <NavLink to="/tablas">Tablas</NavLink>
          <NavLink to="/cargas">Cargas</NavLink>
          <NavLink to="/versiones">Versiones</NavLink>
          <NavLink to="/claves">Claves de API</NavLink>
          <SiPuede rol="dwh.admin">
            <NavLink to="/auditoria">Auditoría</NavLink>
          </SiPuede>
        </nav>
        <div className="usuario">
          <span title={me.email ?? undefined}>{me.nombre ?? me.email}</span>
          <span className="rol">{me.rol?.replace('dwh.', '')}</span>
          <button type="button" className="boton boton-claro" onClick={() => void salir()}>
            Salir
          </button>
        </div>
      </header>
      <main className="contenido">
        <Outlet />
      </main>
    </div>
  );
}
